<template>
  <v-col cols="12" class="pa-0 pl-5 pr-5">
    <v-sheet rounded="lg">
      <v-container fluid>
        <h1>Acesso</h1>
        <paragrafo>
          Ao realizar o primeiro acesso, o usuário receberá um login por e-mail
          e logo após acessar o aplicativo deverá criar uma nova senha.
        </paragrafo>
        <paragrafo
          >Após isso, preencha todos os campos com seus dados.
        </paragrafo>
        <v-row justify="center">
          <imagem :src="image_1" />
        </v-row>
      </v-container>
    </v-sheet>
  </v-col>
</template>
<script>
export default {
  name: "acesso",
  components: {
    paragrafo: () => import("@/docs/components/infos/paragrafo.vue"),
    imagem: () => import("@/docs/components/infos/imagem_pos.vue"),
    // negrito: () => import("@/docs/components/infos/negrito.vue"),
  },
  data() {
    return {
      image_1: "/appPontoVenda/pontodevenda/primeira.png",
    };
  },
};
</script>
